<template>
  <v-card
    width="468"
    height="167"
    outlined
    color="white"
    class="sigfloCard subsystemCard sigfloNeutralBorder200"
    @click="openSubsystem(subsystem.systemId, subsystem.id)"
    :loading="configurator.subsystemsLoading"
  >
    <confirmDeleteDialog
      entityType="Subsystem"
      :entityName="subsystem.name"
      :callback="delSubsystem"
      :dialogModel="showConfirmationDialog"
      @close-dialog="showConfirmationDialog = false"
    ></confirmDeleteDialog>
    <v-avatar size="80" color="transparent" class="subsystemProgressCircle">
      <v-progress-circular
        :color="getProgressColor(subsystem.percentComplete)"
        :value="subsystem.percentComplete"
        size="60"
        width="6"
        ><span class="progressCircleText">{{ subsystem.percentComplete }}%</span></v-progress-circular
      >
    </v-avatar>
    <div class="subsystemTitle sigfloH5 black--text">{{ subsystem.name }}</div>
    <div class="subsystemSubtitle sigfloBodySmall textMuted pr-5">
      {{ subsystem.description }}
    </div>
    <div class="subsystemTotal sigfloBody400">Total: ${{ formatPrice(subsystem.sellPrice) }}</div>
    <v-btn
      text
      color="#F9F6FD"
      class="viewButton text-capitalize textEmphasis"
      @click.stop.prevent="openSubsystem(subsystem.systemId, subsystem.id)"
      >View</v-btn
    >
    <v-btn icon class="deleteButton" color="#625676" plain @click.stop.prevent="confirmDelSubsystem"
      ><v-icon>mdi-delete-outline</v-icon></v-btn
    >
  </v-card>
</template>

<script>
  import confirmDeleteDialog from '@/components/shared/ConfirmDeleteDialog.vue';
  import { mapState } from 'vuex';

  export default {
    components: {
      confirmDeleteDialog
    },
    props: {
      subsystem: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        showConfirmationDialog: false
      };
    },
    methods: {
      /**
       * Deletes a subsystem
       */
      delSubsystem() {
        this.deleteSubsystem(this.subsystem.id);
      },
      /**
       * Shows confirmation window
       */
      confirmDelSubsystem() {
        const message = `Delete ${this.subsystem.name} System?`;
        this.showPlainDialog({
          display: 'Now',
          message: message,
          messageTitle: 'Confirm',
          parentId: 0,
          parentType: '',
          published: true,
          buttonArray: [
            {
              label: 'Delete',
              callback: this.delSubsystem,
              icon: 'mdi-close',
              color: 'red'
            },
            {
              label: 'Cancel',
              callback: this.closePlainDialog,
              icon: '',
              color: 'grey'
            }
          ]
        });
      }
    },
    computed: {
      ...mapState(['configurator']),
      /**
       * Returns the text for adding a system.
       *
       * @returns {string} The text for adding a system.
       */
      getAddText() {
        let article = 'a';
        if (
          this.system.name.charAt(0).toLowerCase() === 'a' ||
          this.system.name.charAt(0).toLowerCase() === 'e' ||
          this.system.name.charAt(0).toLowerCase() === 'i' ||
          this.system.name.charAt(0).toLowerCase() === 'o' ||
          this.system.name.charAt(0).toLowerCase() === 'u'
        ) {
          article = 'an';
        }
        return `Add ${article} ${this.system.name} System`;
      }
    }
  };
</script>

<style scoped>
  .subsystemCard {
    background-color: #f9f6fd !important;
    border: 1px solid #e9e5ee !important;
  }
  .subsystemProgressCircle {
    position: absolute;
    left: 25px;
    top: 15px;
  }
  .subsystemTitle {
    padding-left: 120px;
    padding-top: 25px;
    /* position: absolute;
    top: 25px;
    left: 120px; */
  }
  .subsystemSubtitle {
    padding-top: 5px;
    padding-left: 120px;
    /* position: absolute;
    top: 56px;
    left: 120px; */
  }
  .subsystemTotal {
    position: absolute;
    bottom: 10px;
    left: 120px;
  }
  .viewButton {
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
  .deleteButton {
    position: absolute;
    top: 15px;
    right: 25px;
  }
</style>
